import { defineStore } from "pinia"

export const useTestStore = defineStore('test', {
    state: () => ({}),
    actions: {
        clear(payload) {
            Object.assign(this.$state, payload)
        }
    }
  })
